import { createFileRoute } from '@tanstack/react-router';
import { SchedulePage } from '@/features/Schedule/SchedulePage';

export const Route = createFileRoute('/_student/schedule/')({ component: SchedulePage });
